export default {
  ACTIVE: 'active',
  COMPANY_ID: 'company_id',
  COMPANY_NAME: 'company_name',
  CREATED: '$created',
  DOCS_CREATED: 'documents_count',
  EMAIL: '$email',
  FIRST_NAME: '$first_name',
  LAST_NAME: '$last_name',
  OWNER: 'owner',
  PHOTOS_COUNT: 'photos_count',
  PROJECT_COUNT: 'projects_count',
  REFERRAL_LINKS_SHARED: 'referral_links_shared',
  USER_ID: 'user_id',
  VIDEOS_COUNT: 'videos_count',
  // $phone?
  // $avatar?
};
